import { useState, useCallback, useEffect } from "react";

const carouselImages = [
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/b24f2225-ee94-46bf-82ef-0206c2207e00/public", //op_3D_TD01.webp
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/e9de6fdc-e563-46b9-b6a5-11d608fb2500/public", //op_3D_TD04.webp
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/12471cef-124d-4f8a-9905-c6de7e9eed00/public", //op_3D_TD03.webp
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/ff97a8e6-f913-4d85-d266-03ab6c20c600/public", //op_3D_TD02.webp
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9ac1e4c7-4c53-4d00-1ff5-52916ba17c00/public", //op_3D_TD05.webp
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/99047f01-eaeb-4468-b0ae-ac713b4acc00/public", //op_3D_TD06.webp
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/7da6de56-3ace-4508-423d-b1b8bbc47a00/public", //op_3D_TD07.webp
];

export default function Carousel() {
    const [touchStartY, setTouchStartY] = useState(null);
  const [current, setCurrent] = useState(0);
  const [disable, setDisable] = useState(false);

  const changeSlide = useCallback(
    (index) => {
      if (disable) return;
      setDisable(true);

      const newIndex =
        (index + carouselImages.length) % carouselImages.length;
      setCurrent(newIndex);

      setTimeout(() => setDisable(false), 800);
    },
    [disable]
  );

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "ArrowUp") changeSlide(current - 1);
      if (e.key === "ArrowDown") changeSlide(current + 1);
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [current, changeSlide]);

  return (
    <div className="lg:hidden block">
      <div
        className="w-full min-h-screen flex items-center justify-center overflow-hidden px-4"
        onWheel={(e) => {
            e.preventDefault();
            if (e.deltaY > 0) changeSlide(current + 1);
            else changeSlide(current - 1);
        }}
        onTouchStart={(e) => {
            setTouchStartY(e.touches[0].clientY);
        }}
        onTouchMove={(e) => {
            if (touchStartY === null) return;

            const touchEndY = e.touches[0].clientY;
            const diff = touchStartY - touchEndY;

            if (Math.abs(diff) > 50) {
            if (diff > 0) changeSlide(current + 1);
            else changeSlide(current - 1);
            setTouchStartY(null);
            }
        }}
        >

        <div className="flex w-full max-w-[1200px] h-[80vh] gap-16 justify-center items-center max-md:flex-col max-md:h-auto max-md:gap-6">
          <div className="flex justify-center items-center flex-1">
            <div className="relative w-full max-w-[500px] h-[70vh] flex flex-col items-center perspective-[1000px] max-md:h-[60vh] max-md:max-w-[350px]">
              <div className="relative w-[450px] h-full flex flex-col justify-center items-center transition-transform duration-[800ms] ease-custom transform-style-3d max-md:w-[350px]">
                {carouselImages.map((src, i) => {
                  const offset =
                    (i - current + carouselImages.length) %
                    carouselImages.length;

                  let cls =
                    "absolute bg-white shadow-2xl overflow-hidden cursor-pointer transition-all duration-[800ms] ease-custom";
                  let transform = "";
                  let opacity = "opacity-0 pointer-events-none";
                  let gray = "grayscale";

                  if (offset === 0) {
                    opacity = "opacity-100";
                    gray = "";
                    transform = "scale-[1.1] translate-z-[0px] z-10";
                  } else if (offset === 1) {
                    transform =
                      "translate-y-[150px] scale-[0.9] translate-z-[-100px] opacity-90 z-5";
                  } else if (offset === 2) {
                    transform =
                      "translate-y-[300px] scale-[0.8] translate-z-[-300px] opacity-70 z-0";
                  } else if (offset === carouselImages.length - 1) {
                    transform =
                      "translate-y-[-150px] scale-[0.9] translate-z-[-100px] opacity-90 z-5";
                  } else if (offset === carouselImages.length - 2) {
                    transform =
                      "translate-y-[-300px] scale-[0.8] translate-z-[-300px] opacity-70 z-0";
                  }

                  return (
                    <div
                      key={i}
                      onClick={() => changeSlide(i)}
                      className={`${cls} ${opacity} ${transform} w-[270px] h-[180px] sm:w-[320px] sm:h-[180px]`}
                    >
                      <img
                        src={src}
                        alt="img"
                        className={`w-full h-full object-cover transition-all duration-[800ms] ease-custom ${gray}`}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
